module.exports = __webpack_public_path__ + "img/01.05d87ba8.jpeg";